// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AccountingSubscriptions } from '../../../../types/server/modules/accounting/subscriptions';

export type * from '../../../../types/server/modules/accounting/subscriptions';

export const createSubscriptions = ( requests: Requests ): AccountingSubscriptions => ({
  AccountingAccounts: ( params, onChange ) => {
          return requests.subscribe( `/accounting/accounts/:id?`, params, 'AccountingAccounts', onChange );
          }
});
